export class ConnectionQualityService {
  constructor($interval, $rootScope) {
    'ngInject';

    this.$rootScope = $rootScope;
    this.$interval = $interval;

    this.isSlow = false;
    this.interval = $interval(() =>this.getNetworkInformation(), 30000);

    this.getNetworkInformation();
  }

  getNetworkInformation() {
    if (navigator.connection) {
      const downlink = navigator.connection.downlink;
      const isSlow = downlink < 0.5;

      if (this.isSlow !== isSlow) {
        this.isSlow = isSlow;
        this.$rootScope.$broadcast('connectionQualityChanged');
      }
    }
  }

  stopMonitoring() {
    if (this.interval) {
        this.$interval.cancel(this.interval);
    }
  }
}